import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function ConsumerAffairs(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#196BA3" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M12 4.30005L6 5.80332V13.6203C6 17.5288 12 19.6334 12 19.6334C12 19.6334 18 17.5288 18 13.6203V5.80332L12 4.30005ZM10.2882 12.3738L9.88407 14.7351L12.0001 13.6202L14.1161 14.7351L13.712 12.3738L15.4239 10.7014L13.0581 10.3569L12.0001 8.20847L10.9421 10.3569L8.57629 10.7014L10.2882 12.3738Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

ConsumerAffairs.propTypes = propTypes;
ConsumerAffairs.defaultProps = defaultProps;

export default ConsumerAffairs;
